import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Clock } from "lucide-react";
import { api, imgUrl } from "../lib/api";
import { waFor } from "../lib/site";
import { useSite } from "../context/SiteContext";
import { Seo } from "../components/site/Seo";
import { PageHeader } from "../components/site/PageHeader";
import { RichText } from "../components/site/RichText";
import { AsideCta } from "../components/site/AsideCta";
import { DiscountBadge, ServiceGrid } from "../components/site/ServiceCard";
import { SectionTitle } from "../components/site/SectionTitle";
import { ContactSection } from "../components/site/ContactSection";
import NotFound from "./NotFound";

export default function ServiceDetail() {
  const { slug } = useParams();
  const { services } = useSite();
  const [svc, setSvc] = useState(undefined);

  useEffect(() => {
    setSvc(undefined);
    api.get(`/services/${slug}`).then((r) => setSvc(r.data)).catch(() => setSvc(null));
  }, [slug]);

  if (svc === null) return <NotFound />;
  if (!svc) return <div className="min-h-[60vh]" data-testid="service-loading" />;

  const path = `/hizmet/${svc.slug}`;
  const crumbs = [{ to: "/", label: "Ana Sayfa" }, { to: "/masaj-hizmetleri", label: "Masaj Hizmetleri" }, { to: path, label: svc.title }];
  const others = services.filter((s) => s.slug !== svc.slug).slice(0, 3);
  return (
    <>
      <Seo title={svc.seo_title || `Sivas ${svc.title} | Lunessa Spa Masaj`} description={svc.meta_description || svc.short_desc} path={path} image={svc.image} breadcrumbs={crumbs} />
      <PageHeader eyebrow="Hizmet Detayı" h1={`Sivas ${svc.title}`} intro={svc.short_desc} image={imgUrl(svc.image)} imageAlt={`lunessa-sivas-${svc.slug}`} crumbs={crumbs}>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <DiscountBadge testId="service-detail-badge" />
          {svc.duration && (
            <span className="inline-flex items-center gap-1.5 rounded-full border border-white/25 px-3 py-1 text-xs text-white/85" data-testid="service-detail-duration">
              <Clock className="h-3.5 w-3.5 text-gold-light" /> {svc.duration}
            </span>
          )}
        </div>
      </PageHeader>
      <div className="container-lux grid gap-12 py-16 lg:grid-cols-[minmax(0,1fr)_340px] lg:gap-16 lg:py-24">
        <article className="min-w-0" data-testid="service-detail-article">
          <img src={imgUrl(svc.image)} alt={`lunessa-sivas-${svc.slug}`} loading="lazy" className="mb-10 aspect-[16/10] w-full rounded-3xl object-cover shadow-[0_24px_50px_-30px_rgba(2,44,34,0.5)]" />
          <RichText text={svc.long_desc} />
          <p className="prose-lux mt-8">
            Diğer seçenekler için <Link to="/masaj-hizmetleri">tüm masaj hizmetlerimizi</Link> inceleyebilir, randevu için <Link to="/iletisim">iletişim</Link> sayfamızı ziyaret edebilirsiniz.
          </p>
        </article>
        <AsideCta current={path} waHref={waFor(svc.title)} />
      </div>
      {others.length > 0 && (
        <section className="bg-cream-grad py-20" data-testid="related-services">
          <div className="container-lux">
            <SectionTitle eyebrow="Diğer Hizmetler" title="Bunları da Beğenebilirsiniz" />
            <ServiceGrid services={others} />
          </div>
        </section>
      )}
      <ContactSection />
    </>
  );
}
